import { render, staticRenderFns } from "./DetailPaymentKasbonCombination.vue?vue&type=template&id=4a4cd9b8"
import script from "./DetailPaymentKasbonCombination.vue?vue&type=script&lang=js"
export * from "./DetailPaymentKasbonCombination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports